export default {
  validation: {
    required: 'นี่เป็นคำถามที่จำเป็น',
    kana_format: '',
    email_format: 'พิมพ์ใน @.lower:validation.variables.email',
    date_format: 'พิมพ์ใน @.lower:validation.variables.date',
    number_format: 'พิมพ์ใน @.lower:validation.variables.number',
    halfwidth_number_format: 'พิมพ์เฉพาะตัวเลขแบบครึ่งความกว้างเท่านั้น',
    alphanumeric_format: 'พิมพ์ใน @.lower:validation.variables.alphanumeric',
    postal_number_no_hyphen: 'พิมพ์ใน @.lower:validation.variables.postal_number',
    postal_number_format: 'พิมพ์ @:validation.variables.postal_number ใน ไม่มียัติภังค์',
    login_email_required: '@:validation.required',
    login_email_format: '@:validation.email_format',
    login_password_required: '@:validation.required',
    login_password_format: 'พิมพ์ใน 6 ตัวอักษรหรือมากกว่า',
    min_length: 'พิมพ์ใน {length} ตัวอักษรหรือมากกว่า',
    max_length: 'พิมพ์ใน {length} ตัวอักษรหรือน้อยกว่า',
    // greater_than_or_equal_number: "",
    // greater_than_number: "",
    // less_than_or_equal_number: "",
    // less_than_number: "",
    max_digit: 'โปรดป้อนไม่เกิน {digit} หลัก',
    max_digit_with_item: 'กรุณาเข้าสู่ระบบ {item} ภายใน {digit} หลัก',
    // number_only: "",
    // decimal_max_digit: "",
    no_blank_or_newline: 'ไม่อนุญาตให้ตอบด้วยการเว้นวรรคและ/หรือการขึ้นบรรทัดใหม่เท่านั้น',
    // invalid_zero_number: "",
    variables: {
      id_or_email: 'ID/ที่อยู่อีเมล',
      email: 'ที่อยู่อีเมล',
      password: 'รหัสผ่าน',
      kana: '',
      date: 'วันที่ (เช่น 31/01/2023)',
      number: 'ตัวเลข',
      alphanumeric: 'ตัวอักษรและตัวเลข',
      postal_number: 'รหัสไปรษณีย์',
    },
  },
}
